module.exports = __webpack_public_path__ + "static/image/company/pc/visual.jpg?ded120c2";